import gql from 'graphql-tag'

export const stepProposalFragments = gql`
  fragment StepProposalResultDetails on StepProposalResult {
    errors
    proposals {
      id
      name
      instructionText
      durationInSeconds
      uploadProposals {
        id
        fragmentStartInMillis
        fragmentEndInMillis
        upload {
          id
          url
          extension {
            ... on VideoExtension {
              url
            }
          }
        }
      }
      checkProposals {
        id
        type
        description
        upperLimit
        lowerLimit
        isRequired
      }
    }
  }
`
